import React, { FC, Fragment } from "react";
import { Icon } from "../icon";
import { Button } from "../../modules";
import ImportInput from "./ImportInput";

export interface IImportPopupProps {
	onImport: (form: FormData ,cb: any) => void
  onClose: () => void;
  toggleModal: () => void;
  fileUrl: string
}

export const ImportPopup: FC<IImportPopupProps> = ({ onClose, onImport, fileUrl, toggleModal }) => {
  return (
    <Fragment>
      {(() => {
          const id = `popup-confirm-import`;
          return (
            <div
              className="confirm-import-popup"
              id={id}
            >
              <div className="box">
                <div className="head">
                  Nhập file excel
                  <div className="btnClose" onClick={onClose} >
                    <Icon.Close />
                  </div>
                </div>
                <div className="content">
                  <p>Click để tải file mẫu</p>
                  <Button
                    label="Tải file mẫu"
                    buttonType="info"
                    onClick={() => window?.open(fileUrl)}
                  />
                  <ImportInput onImport={onImport} toggleModal={toggleModal}/>
                </div>
              </div>
            </div>
          );
        
      })()}
    </Fragment>
  );
};
